var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"o-autobuyer-input",class:_vm.validityClass,attrs:{"type":_vm.inputType},domProps:{"value":_vm.displayValue},on:{"change":_vm.handleChange,"focus":_vm.handleFocus,"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }